import React from 'react';

const Header = () => {
    return (
        <div className='adminHead'>
            <span> <h1> Admininistrator Dashboard </h1></span>
        </div>
    )
}

export default Header


// WEBPACK FOOTER //
// ./src/Pages/Admin/AdminHeader.js